module.exports = __webpack_public_path__ + "static/img/PAT_CUMMINS.1eaeede.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PAT_CUMMINS.jpg
// module id = d/4h
// module chunks = 0